// Temperature options
const temperatures = [
  {
    id: 1,
    name: "Hot",
  },
  {
    id: 2,
    name: "Cold",
  },
];

export default temperatures;
